/**
 * 取消关注目标用户
 * @param user_id
 */
export async function requestUnfollow(user_id: number) {
  return http.post('/v1/follow/follow', {
    user_id,
    unfollow: 1
  })
}
